var app = app ||  {};
app.dashboard = app.dashboard || {};

;(function(namespace, $){

  var Dashboard = function() {

    

    function _construct() {
    }

    _construct();

  };

  var main = new Dashboard();

})(app.dashboard, jQuery);


